import * as React from 'react';
export const MediaContext = React.createContext(undefined);
export const SetMediaContext = React.createContext(undefined);
export const MediaContextProvider = (props) => {
    const [media, setMedia] = React.useState();
    return (React.createElement(SetMediaContext.Provider, { value: setMedia },
        React.createElement(MediaContext.Provider, { value: media }, props.children)));
};
